import { FETCH_USER_BY_ID, ERROR_FETCH_USER_BY_ID } from '../actions/types';

const initialState = {
  user: {},
  loading: true,
};
export default function (state = initialState, action) {
  const { type, payload } = action;
  // console.log('state', payload);
  switch (type) {
    case FETCH_USER_BY_ID:
      return {
        ...state,
        user: payload,
        loading: false,
      };
    case ERROR_FETCH_USER_BY_ID:
      return { ...state, user: null, loading: true };
    default:
      return state;
  }
}
